import { render, staticRenderFns } from "./PointOfInterest.vue?vue&type=template&id=3f335104&scoped=true&"
import script from "./PointOfInterest.vue?vue&type=script&lang=js&"
export * from "./PointOfInterest.vue?vue&type=script&lang=js&"
import style0 from "./PointOfInterest.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PointOfInterest.vue?vue&type=style&index=1&id=3f335104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f335104",
  null
  
)

export default component.exports